import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import AuthLayout from './layout/AuthLayout';
import { authRoutes } from './routes/authroutes';
import AuthFailure from './pages/authFailure';
import NotFound from './pages/404';
import ForgotPassword from './pages/forgotPassword';
import ResetPassword from './pages/resetPassword';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<AuthLayout />}>
					{authRoutes}
				</Route>
				<Route path="/unauthorised" element={<AuthFailure />} />
				<Route path="/forgotPassword" element={<ForgotPassword />} />
				<Route path="/resetPassword" element={<ResetPassword />}/>
				<Route path="*" element={<NotFound />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;